import normalize from 'json-api-normalizer';

import QuestionChoice from './question_choice';
import QuestionParamValue from './question_param_value';
import QuestionType from './question_type';
import Survey from './survey';

export default class Question {
	static from (jsonapi) {
		let key = 'questions'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Question.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Question.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}

		if (normalizedJSONapi['surveys'] && normalizedJSONapi['surveys'][attributes['surveyId']] && noRelationships == 0) {
			relationships['survey'] = Survey.make(normalizedJSONapi['surveys'][attributes['surveyId']], normalizedJSONapi, 1);
		}

		if (normalizedJSONapi['questions'] && normalizedJSONapi['questions'][attributes['parentId']] && noRelationships == 0) {
			relationships['parent'] = Question.make(normalizedJSONapi['questions'][attributes['parentId']], normalizedJSONapi, 1);
		}

		if (jsonapi.relationships && jsonapi.relationships['questionType'] && normalizedJSONapi['questionTypes'] && noRelationships == 0) {
			let rel = jsonapi.relationships['questionType']['data'];
			relationships['questionType'] = QuestionType.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
		}

		if (jsonapi.relationships && jsonapi.relationships['questionChoices'] && normalizedJSONapi['questionChoices'] && noRelationships == 0) {
			relationships['questionChoices'] = {};
			jsonapi.relationships['questionChoices'].data.forEach( function (rel) {
				relationships['questionChoices'][rel.id] = QuestionChoice.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
			const choicesArray = Object.values(relationships['questionChoices']);

			// Sort the choices array by the 'number' field
			const sortedChoicesArray = choicesArray.sort((a, b) => a.number - b.number);

			const sortedChoicesObject = sortedChoicesArray.reduce((acc, choice, index) => {
				acc[index] = choice;
				return acc;
			}, {});
			
			// Output the sorted choices object
			relationships['questionChoices'] = sortedChoicesObject
		}

		if (jsonapi.relationships && jsonapi.relationships['rows'] && normalizedJSONapi['questions'] && noRelationships == 0) {
			relationships['rows'] = {};
			//console.log({rows: jsonapi.relationships['rows'].data, normalizedJSONapi});
			jsonapi.relationships['rows'].data.forEach( function (rel) {
				//console.log ({rel});
				relationships['rows'][rel.id] = Question.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		if (jsonapi.relationships && jsonapi.relationships['questionParamValues'] && normalizedJSONapi['questionParamValues'] && noRelationships == 0) {
			relationships['questionParamValues'] = {};
			jsonapi.relationships['questionParamValues'].data.forEach( function (rel) {
				relationships['questionParamValues'][rel.id] = QuestionParamValue.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		return new Question ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, varname, title, surveyId, survey, parentId, parent, number, questionChoices, questionParamValues, questionType, questionTypeId, rows, html }) {
		this.id               = id ? id : -1;
		this.survey_id        = surveyId ? surveyId : null;
		this.survey           = survey ? survey : null;
		this.parent_id        = parentId ? parentId : null;
		this.parent           = parent ? parent : null;
		this.varname          = varname;
		this.title            = title;
		this.number           = Number(number) ? Number(number) : 1;
		this.question_type    = questionType ? questionType : null;
		this.question_type_id = questionTypeId ? questionTypeId : -1;
		this.type             = questionType ? questionType.name : '';
		this.rows             = rows ? rows : {};
		this.deleted          = 0;

		this.choices          = {};
		this.rate_values      = {};
		this.columns          = {};
		this.html			  = html ? html : '';

		if (questionType && questionType.include_choices) {
			switch (questionType.choices_name) {
				case 'choices':
					this.choices     = questionChoices ? questionChoices : {};
					break;
				case 'rateValues':
					this.rate_values = questionChoices ? questionChoices : {};
					break;
				case 'columns':
					this.columns     = questionChoices ? questionChoices : {};
					break;
			}
		}
		this.params     = questionParamValues? questionParamValues : {};
	}

	toJSONapi (fullTranslation) {
		let attributes = Object.assign({}, this);

		let relationships = {};
		let included = [];

		if (attributes.question_type != null) {
			attributes.question_type_id = attributes.question_type['id'];
		}
		delete attributes.question_type;


		/*
		relationships['question_types'] = {};
		relationships['question_types']['data'] = {'id': attributes.question_type['id'], 'type': 'question_types'}
		if (fullTranslation) {
			let jsonapi = attributes.question_type.toJSONapi();
			included.push(jsonapi['data'])
		}
		delete attributes.question_type;
		*/

		let params = attributes.params
		delete attributes.params

		relationships['question_param_values'] = {};
		relationships['question_param_values']['data'] = [];

		let keys = Object.keys(params);
		for (let i = 0; i < keys.length; i++ ) {
			relationships['question_param_values']['data'].push({'id': keys[i], 'type': 'question_param_values'})
			if (fullTranslation) {
				let jsonapi = params[keys[i]].toJSONapi(true)
				included.push(jsonapi['data'])
			}
		}

		let rows = attributes.rows
		delete attributes.rows

		keys = Object.keys(rows);
		for (let i = 0; i < keys.length; i++ ) {
			relationships['rows']['data'].push({'id': keys[i], 'type': 'question'})
			if (fullTranslation) {
				let jsonapi = rows[keys[i]].toJSONapi(true)
				included.push(jsonapi['data'])
			}
		}

		relationships['question_choices'] = {}
		relationships['question_choices']['data'] = []

		let choices = attributes.choices
		delete attributes.choices

		//if (this.question_type.choices_name == 'choices' && this.question_type.include_choices) {
			keys = Object.keys(choices);
			for (let i = 0; i < keys.length; i++) {
				relationships['question_choices']['data'].push({'id': keys[i], 'type': 'question_choices'})
				if (fullTranslation) {
					let jsonapi = choices[keys[i]].toJSONapi()
					included.push(jsonapi['data'])
				}
			}
		//}

		let rate_values = attributes.rate_values
		delete attributes.rate_values

		//if (this.question_type.choices_name == 'rateValues' && this.question_type.include_choices) {
			keys = Object.keys(rate_values);
			for (let i = 0; i < keys.length; i++) {
				relationships['question_choices']['data'].push({'id': keys[i], 'type': 'question_choices'})
				if (fullTranslation) {
					let jsonapi = rate_values[keys[i]].toJSONapi()
					included.push(jsonapi['data'])
				}
			}
		//}

		let columns = attributes.columns
		delete attributes.columns

		//if (this.question_type.choices_name == 'rateValues' && this.question_type.include_choices) {
			keys = Object.keys(columns);
			for (let i = 0; i < keys.length; i++) {
				relationships['question_choices']['data'].push({'id': keys[i], 'type': 'question_choices'})
				if (fullTranslation) {
					let jsonapi = columns[keys[i]].toJSONapi()
					included.push(jsonapi['data'])
				}
			}
		//}

		return {data: {type: "questions", id: this.id, attributes, relationships}, included};
	}
}
